// API Base URL Configuration
export const baseUrl = 'https://vamana.store/api/member/';
export const imageBaseUrl = 'https://vamana.store';

// export const baseUrl = 'http://localhost:5001/api/member/';
// export const imageBaseUrl = 'http://localhost:5001';
